export const getById = state => state.clients.byId
export const getMember = (state, id) => state.clients.byId[id]
export const getCollection = (state, ids) =>
  ids.map(id => state.clients.byId[id])
export const getSearch = state => state.clients.search
export const getIsLoading = state => state.clients.isLoading
export const getIsCreating = state => state.clients.isCreating
export const getIsUpdating = state => state.clients.isUpdating
